import type { BillingInterval } from '@vy/types';
import { BILLING_INTERVALS } from '@vy/types';
import { raiseUnreachable } from '@vy/utils';

export function getBillingIntervalLabel(billingInterval: BillingInterval) {
  switch (billingInterval) {
    case BILLING_INTERVALS.Monthly:
      return 'Monthly';
    case BILLING_INTERVALS.Quarterly:
      return 'Quarterly';
    case BILLING_INTERVALS.Yearly:
      return 'Yearly';
    case BILLING_INTERVALS.SixMonths:
      return 'Every 6 months';
    case BILLING_INTERVALS.BiMonthly:
      return 'Bi Monthly';
    default:
      return raiseUnreachable(billingInterval);
  }
}
